import React, { useState, useEffect } from 'react';
import './ProgressiveBackToTop.css';

const ProgressiveBackToTop = () => {
    const [progress, setProgress] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPosition = window.scrollY;
            
            // Calculate progress (0 to 100)
            const currentProgress = totalHeight > 0 ? (scrollPosition / totalHeight) * 100 : 0;
            setProgress(currentProgress);

            // Show button after 300px scroll
            if (scrollPosition > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // SVG Circle Math
    const radius = 28;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <div 
            className={`progressive-back-to-top ${isVisible ? 'visible' : ''}`} 
            onClick={scrollToTop}
            title="Back to Top"
        >
            <svg className="progress-svg" viewBox="0 0 60 60">
                <circle 
                    className="progressive-circle-bg" 
                    cx="30" cy="30" r={radius} 
                />
                <circle 
                    className="progressive-circle-bar" 
                    cx="30" cy="30" r={radius} 
                    style={{ 
                        strokeDasharray: circumference, 
                        strokeDashoffset: offset 
                    }}
                />
            </svg>
            <div className="progress-icon">
                <svg className="arrow-svg" viewBox="0 0 24 24">
                    <path d="M12 4l-8 8h6v8h4v-8h6z" />
                </svg>
            </div>
        </div>
    );
};

export default ProgressiveBackToTop;
